import { useEffect, Dispatch, SetStateAction, RefObject } from "react";

export function useCloseOnScrollAndClickOutside(
  setIsOpen: Dispatch<SetStateAction<boolean>>,
  menuRef: RefObject<HTMLElement>
) {
  useEffect(() => {
    const handleClose = () => {
      setIsOpen(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        handleClose();
      }
    };

    window.addEventListener("scroll", handleClose, { passive: true });
    window.addEventListener("pointerdown", handleClickOutside);

    window.addEventListener("blur", handleClose);
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        handleClose();
      }
    });
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleClose);
      window.removeEventListener("pointerdown", handleClose);
      window.removeEventListener("blur", handleClose);
      document.removeEventListener("visibilitychange", handleClose);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsOpen, menuRef]);
}
